import React from 'react';
import moment from 'moment';
import { View } from 'react-native';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
const weekdays = moment.weekdays();
export const Titles = () => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, null, weekdays.map((day, index) => (React.createElement(View, { key: day, style: [styles.wrapper, index !== 0 ? styles.wrapperWithMargin : {}] },
        React.createElement(View, { style: styles.title }))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    wrapper: {
        width: size.M,
        height: size.M,
        alignItems: 'flex-start',
        justifyContent: 'center'
    },
    title: {
        backgroundColor: color.invert2.p4,
        borderRadius: 6,
        width: size.L,
        height: size.H
    },
    wrapperWithMargin: { marginTop: size.C }
}));
//# sourceMappingURL=Titles.js.map